import { render, staticRenderFns } from "./slideImage.vue?vue&type=template&id=13b96bee&scoped=true"
import script from "./slideImage.vue?vue&type=script&lang=js"
export * from "./slideImage.vue?vue&type=script&lang=js"
import style0 from "./slideImage.vue?vue&type=style&index=0&id=13b96bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b96bee",
  null
  
)

export default component.exports